import { createPortal } from 'react-dom';

import { TailwindWrapper } from '@utils/TailwindWrapper';
import { Button, Dialog, Icon, Loader, Text } from '@ui-component-library';

/**
 * Naturvårdsverket WMS GetFeatureInfo — same pattern as {@link Karta.js} layer info (`Dialog` + portal).
 * Lists only layer names (hits), not full attribute rows.
 * @param {HTMLElement | null} portalContainer — map shell so the dialog stacks above the map in fullscreen.
 */
export default function SellTimberWmsIdentifyModal({
  isOpen,
  loading,
  sections,
  onClose,
  portalContainer
}) {
  const modal = (
    <TailwindWrapper>
      <Dialog isOpen={isOpen} onClose={onClose} size="large">
        <Dialog.Header className="items-center">
          <Text variant="text-lg/leading-normal/medium" className="mb-0 flex-1 pr-2">
            Skyddad natur (Naturvårdsverket)
          </Text>
          <Button variant="tertiary" size="icon" onClick={onClose} aria-label="Stäng">
            <Icon name="CrossSimple" className="color-charcoal-500" size="medium" />
          </Button>
        </Dialog.Header>
        <Dialog.Content
          aria-busy={loading}
          style={{ minHeight: loading ? 140 : undefined }}
        >
          {loading ? (
            <div className="flex flex-col items-center justify-center gap-3 py-8">
              <Loader size="large" />
              <Text variant="text-base/leading-normal/normal" className="text-center">
                Hämtar information från kartlagren…
              </Text>
            </div>
          ) : !sections || sections.length === 0 ? (
            <Text variant="text-base/leading-normal/normal" as="p" className="mb-0">
              Ingen information hittades för denna punkt i de valda lagren.
            </Text>
          ) : (
            <div className="text-start">
              {sections.map((s, idx) => (
                <Text
                  key={`${s.label}-${idx}`}
                  variant="text-sm/leading-normal/bold"
                  as="div"
                  className="mb-2 last:mb-0"
                >
                  {s.label}
                </Text>
              ))}
            </div>
          )}
        </Dialog.Content>
        <Dialog.Footer>
          <Button variant="primary" className="w-full md:w-auto" onClick={onClose}>
            Stäng
          </Button>
        </Dialog.Footer>
      </Dialog>
    </TailwindWrapper>
  );

  const target = portalContainer ?? (typeof document !== 'undefined' ? document.body : null);
  if (!target) {
    return null;
  }
  return createPortal(modal, target);
}
